<template>
  <div class="proDetails">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <div class="container">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/product' }">产品中心</el-breadcrumb-item>
          <el-breadcrumb-item v-if="infoData.length">{{infoData[0].ProductName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    
    <!-- 产品详情主体区域 -->
    <div class="container">
      <div class="product-container" v-if="infoData.length">
        <!-- 产品基本信息区域 -->
        <div class="product-overview">
          <!-- 左侧产品图片 -->
          <div class="product-gallery">
            <div class="main-image">
              <img :src="infoData[0].ProductImg" :alt="infoData[0].ProductName">
              <div class="image-actions">
                <div class="zoom-btn" @click="showLightbox = true">
                  <i class="el-icon-zoom-in"></i>
                  <span>查看大图</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 右侧产品信息 -->
          <div class="product-info">
            <h1 class="product-title">{{infoData[0].ProductName}}</h1>
            
            <div class="product-tags" v-if="infoData[0].ProductTags">
              <el-tag v-for="(tag, index) in infoData[0].ProductTags.split(',')" 
                     :key="index" 
                     size="small"
                     effect="plain">
                {{tag}}
              </el-tag>
            </div>
            
            <div class="product-brief" v-if="infoData[0].ProductBrief">
              <p>{{infoData[0].ProductBrief}}</p>
            </div>
            
            <div class="product-actions">
              <el-button type="primary" icon="el-icon-message" @click="showContactDialog">
                立即咨询
              </el-button>
              <el-button icon="el-icon-share">分享产品</el-button>
            </div>
          </div>
        </div>
        
        <!-- 产品详情内容区域 -->
        <div class="product-content">
          <div class="content-main">
            <!-- 产品详情选项卡 -->
            <div class="detail-tabs">
              <el-tabs type="card">
                <el-tab-pane label="产品详情">
                  <div class="detail-section">
                    <h2 class="section-title">产品详情</h2>
                    <div class="detail-content" v-html="infoData[0].ProductDesc"></div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="规格参数" v-if="infoData[0].ProductSpecs">
                  <div class="detail-section">
                    <h2 class="section-title">规格参数</h2>
                    <div class="specs-table">
                      <el-table :data="formatSpecs(infoData[0].ProductSpecs)" stripe>
                        <el-table-column prop="name" label="参数名称" width="180"></el-table-column>
                        <el-table-column prop="value" label="参数值"></el-table-column>
                      </el-table>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="应用案例" v-if="infoData[0].ProductCases">
                  <div class="detail-section">
                    <h2 class="section-title">应用案例</h2>
                    <div class="detail-content" v-html="infoData[0].ProductCases"></div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          
          <!-- 侧边栏 -->
          <div class="content-sidebar">
            <!-- 产品特点 -->
            <div class="sidebar-section" v-if="infoData[0].ProductFeatures">
              <h3 class="sidebar-title">产品特点</h3>
              <ul class="feature-list">
                <li v-for="(feature, index) in infoData[0].ProductFeatures.split(',')" :key="index">
                  <i class="el-icon-check"></i>
                  <span>{{feature}}</span>
                </li>
              </ul>
            </div>
            
            <!-- 相关推荐 -->
            <div class="sidebar-section" v-if="recommendList.length > 0">
              <h3 class="sidebar-title">相关推荐</h3>
              <div class="recommend-list">
                <div class="recommend-item" 
                     v-for="(item, index) in recommendList" 
                     :key="index"
                     @click="handleRecommendClick(item.Id)">
                  <div class="recommend-image">
                    <img :src="item.ProductImg" :alt="item.ProductName">
                  </div>
                  <div class="recommend-info">
                    <h4>{{item.ProductName}}</h4>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 联系我们 -->
            <div class="sidebar-section contact-section">
              <h3 class="sidebar-title">联系我们</h3>
              <p>如果您对产品有任何疑问，请随时联系我们</p>
              <el-button type="primary" icon="el-icon-phone" size="small" @click="showContactDialog">
                立即咨询
              </el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 加载状态 -->
      <div v-else class="loading-container">
        <el-skeleton :rows="10" animated />
      </div>
    </div>
    
    <!-- 图片灯箱 -->
    <el-dialog
      :visible.sync="showLightbox"
      width="80%"
      center
      class="lightbox-dialog"
      :append-to-body="true"
      :show-close="false">
      <div class="lightbox-content" @click="showLightbox = false">
        <img :src="infoData.length ? infoData[0].ProductImg : ''" alt="产品大图">
        <div class="lightbox-close" @click="showLightbox = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </el-dialog>
    
    <!-- 联系对话框 -->
    <el-dialog
      title="产品咨询"
      :visible.sync="contactDialogVisible"
      width="400px"
      center>
      <div class="contact-dialog-header" v-if="infoData.length">
        <div class="contact-product-info">
          <img :src="infoData[0].ProductImg" :alt="infoData[0].ProductName">
          <div>
            <h4>{{infoData[0].ProductName}}</h4>
            <p>请填写您的联系方式，我们将尽快与您联系</p>
          </div>
        </div>
      </div>
      
      <el-form :model="contactForm" :rules="contactRules" ref="contactForm" label-position="top">
        <el-form-item label="您的姓名" prop="name">
          <el-input v-model="contactForm.name" placeholder="请输入您的姓名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="contactForm.phone" placeholder="请输入联系电话" prefix-icon="el-icon-phone"></el-input>
        </el-form-item>
        <el-form-item label="咨询内容" prop="message">
          <el-input type="textarea" v-model="contactForm.message" rows="4" placeholder="请输入您想咨询的内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contactDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitContactForm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "proDetails",
  data(){
    return{
      infoData:[],
      recommendList: [],
      contactDialogVisible: false,
      showLightbox: false,
      contactForm: {
        name: '',
        phone: '',
        message: ''
      },
      contactRules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        message: [{ required: true, message: '请输入咨询内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  methods:{
    //获取产品详情
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntProductIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        // 获取到产品详情后，将分类ID传入获取推荐列表方法
        if(this.infoData.length > 0) {
          this.getRecommendList(this.infoData[0].ProductCate);
        }
      })
    },
    // 获取推荐产品列表
    getRecommendList(cateId){
      let data = {params:{ProductCate: cateId}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntProductSelect', data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        // 过滤掉当前产品，只显示其他同类产品
        const filteredProducts = res.data.filter(item => item.Id !== Number(this.$route.query.Id));
        this.recommendList = filteredProducts.slice(0, 3); // 只取3个推荐产品
      })
    },
    // 点击推荐产品
    handleRecommendClick(id){
      this.getInfo(id);
      this.$router.push({
        path: '/proDetails',
        query: { Id: id }
      });
    },
    // 显示联系对话框
    showContactDialog() {
      this.contactDialogVisible = true;
    },
    // 提交联系表单
    submitContactForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          // 这里可以添加提交表单的逻辑
          this.$message({
            message: '您的咨询已提交，我们会尽快联系您',
            type: 'success',
            duration: 3000
          });
          this.contactDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 格式化规格参数
    formatSpecs(specsString) {
      if (!specsString) return [];
      try {
        // 假设规格参数是以逗号分隔的键值对，如"尺寸:10cm,重量:5kg"
        return specsString.split(',').map(item => {
          const [name, value] = item.split(':');
          return { name, value };
        });
      } catch (e) {
        console.error('规格参数格式化错误:', e);
        return [];
      }
    }
  }
}
</script>

<style scoped>
.proDetails {
  background-color: #f8f9fa;
  padding-bottom: 60px;
}

/* 面包屑导航 */
.breadcrumb-wrapper {
  background-color: #fff;
  padding: 15px 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

/* 容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 产品容器 */
.product-container {
  animation: fadeIn 0.5s ease;
}

/* 产品概览区域 */
.product-overview {
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
  overflow: hidden;
}

/* 产品图片区域 */
.product-gallery {
  width: 45%;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.main-image {
  position: relative;
  width: 100%;
  text-align: center;
}

.main-image img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.image-actions {
  position: absolute;
  bottom: 15px;
  right: 15px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.main-image:hover .image-actions {
  opacity: 1;
}

.zoom-btn {
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.9);
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.zoom-btn i {
  margin-right: 5px;
  color: #1890ff;
}

.zoom-btn:hover {
  background: #1890ff;
  color: white;
}

.zoom-btn:hover i {
  color: white;
}

/* 产品信息区域 */
.product-info {
  flex: 1;
  padding: 30px;
}

.product-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.product-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.product-brief {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
  font-size: 15px;
  border-left: 3px solid #1890ff;
  padding-left: 15px;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 0 4px 4px 0;
}

.product-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

/* 产品内容区域 */
.product-content {
  display: flex;
  gap: 30px;
}

.content-main {
  flex: 3;
  min-width: 0;
}

.content-sidebar {
  flex: 1;
  min-width: 250px;
}

/* 详情选项卡 */
.detail-tabs {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  overflow: hidden;
}

.detail-section {
  padding: 20px;
}

.section-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.detail-content {
  color: #333;
  line-height: 1.8;
  font-size: 14px;
}

.specs-table {
  margin-top: 20px;
}

/* 侧边栏样式 */
.sidebar-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  padding: 20px;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* 产品特点列表 */
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  color: #666;
}

.feature-list li i {
  color: #52c41a;
  margin-right: 10px;
  margin-top: 3px;
}

/* 推荐产品列表 */
.recommend-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.recommend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.recommend-item:hover {
  background: #f0f2f5;
}

.recommend-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.recommend-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommend-info {
  flex: 1;
  min-width: 0;
}

.recommend-info h4 {
  font-size: 14px;
  color: #333;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
}

.recommend-item:hover .recommend-info h4 {
  color: #1890ff;
}

/* 联系我们区域 */
.contact-section {
  text-align: center;
}

.contact-section p {
  margin-bottom: 15px;
  color: #666;
}

/* 图片灯箱 */
.lightbox-dialog :deep(.el-dialog__body) {
  padding: 0;
}

.lightbox-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.9);
  min-height: 500px;
  cursor: zoom-out;
}

.lightbox-content img {
  max-width: 90%;
  max-height: 80vh;
  object-fit: contain;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lightbox-close i {
  color: white;
  font-size: 20px;
}

.lightbox-close:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: rotate(90deg);
}

/* 联系对话框 */
.contact-dialog-header {
  margin-bottom: 20px;
}

.contact-product-info {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.contact-product-info img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.contact-product-info h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.contact-product-info p {
  font-size: 13px;
  color: #666;
  margin: 0;
}

/* 加载状态 */
.loading-container {
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .product-overview {
    flex-direction: column;
  }
  
  .product-gallery {
    width: 100%;
    padding: 20px;
  }
  
  .product-content {
    flex-direction: column;
  }
  
  .content-sidebar {
    order: -1;
  }
}

@media (max-width: 768px) {
  .product-title {
    font-size: 20px;
  }
  
  .product-actions {
    flex-direction: column;
  }
  
  .product-actions .el-button {
    width: 100%;
  }
}
</style>
<template>
  <div class="proDetails">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <div class="container">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/product' }">产品中心</el-breadcrumb-item>
          <el-breadcrumb-item v-if="infoData.length">{{infoData[0].ProductName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    
    <!-- 产品详情主体区域 -->
    <div class="container">
      <div class="product-container" v-if="infoData.length">
        <!-- 产品基本信息区域 -->
        <div class="product-overview">
          <!-- 左侧产品图片 -->
          <div class="product-gallery">
            <div class="main-image">
              <img :src="infoData[0].ProductImg" :alt="infoData[0].ProductName">
              <div class="image-actions">
                <div class="zoom-btn" @click="showLightbox = true">
                  <i class="el-icon-zoom-in"></i>
                  <span>查看大图</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 右侧产品信息 -->
          <div class="product-info">
            <h1 class="product-title">{{infoData[0].ProductName}}</h1>
            
            <div class="product-tags" v-if="infoData[0].ProductTags">
              <el-tag v-for="(tag, index) in infoData[0].ProductTags.split(',')" 
                     :key="index" 
                     size="small"
                     effect="plain">
                {{tag}}
              </el-tag>
            </div>
            
            <div class="product-brief" v-if="infoData[0].ProductBrief">
              <p>{{infoData[0].ProductBrief}}</p>
            </div>
            
            <div class="product-actions">
              <el-button type="primary" icon="el-icon-message" @click="showContactDialog">
                立即咨询
              </el-button>
              <el-button icon="el-icon-share">分享产品</el-button>
            </div>
          </div>
        </div>
        
        <!-- 产品详情内容区域 -->
        <div class="product-content">
          <div class="content-main">
            <!-- 产品详情选项卡 -->
            <div class="detail-tabs">
              <el-tabs type="card">
                <el-tab-pane label="产品详情">
                  <div class="detail-section">
                    <h2 class="section-title">产品详情</h2>
                    <div class="detail-content" v-html="infoData[0].ProductDesc"></div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="规格参数" v-if="infoData[0].ProductSpecs">
                  <div class="detail-section">
                    <h2 class="section-title">规格参数</h2>
                    <div class="specs-table">
                      <el-table :data="formatSpecs(infoData[0].ProductSpecs)" stripe>
                        <el-table-column prop="name" label="参数名称" width="180"></el-table-column>
                        <el-table-column prop="value" label="参数值"></el-table-column>
                      </el-table>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="应用案例" v-if="infoData[0].ProductCases">
                  <div class="detail-section">
                    <h2 class="section-title">应用案例</h2>
                    <div class="detail-content" v-html="infoData[0].ProductCases"></div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          
          <!-- 侧边栏 -->
          <div class="content-sidebar">
            <!-- 产品特点 -->
            <div class="sidebar-section" v-if="infoData[0].ProductFeatures">
              <h3 class="sidebar-title">产品特点</h3>
              <ul class="feature-list">
                <li v-for="(feature, index) in infoData[0].ProductFeatures.split(',')" :key="index">
                  <i class="el-icon-check"></i>
                  <span>{{feature}}</span>
                </li>
              </ul>
            </div>
            
            <!-- 相关推荐 -->
            <div class="sidebar-section" v-if="recommendList.length > 0">
              <h3 class="sidebar-title">相关推荐</h3>
              <div class="recommend-list">
                <div class="recommend-item" 
                     v-for="(item, index) in recommendList" 
                     :key="index"
                     @click="handleRecommendClick(item.Id)">
                  <div class="recommend-image">
                    <img :src="item.ProductImg" :alt="item.ProductName">
                  </div>
                  <div class="recommend-info">
                    <h4>{{item.ProductName}}</h4>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 联系我们 -->
            <div class="sidebar-section contact-section">
              <h3 class="sidebar-title">联系我们</h3>
              <p>如果您对产品有任何疑问，请随时联系我们</p>
              <el-button type="primary" icon="el-icon-phone" size="small" @click="showContactDialog">
                立即咨询
              </el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 加载状态 -->
      <div v-else class="loading-container">
        <el-skeleton :rows="10" animated />
      </div>
    </div>
    
    <!-- 图片灯箱 -->
    <el-dialog
      :visible.sync="showLightbox"
      width="80%"
      center
      class="lightbox-dialog"
      :append-to-body="true"
      :show-close="false">
      <div class="lightbox-content" @click="showLightbox = false">
        <img :src="infoData.length ? infoData[0].ProductImg : ''" alt="产品大图">
        <div class="lightbox-close" @click="showLightbox = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </el-dialog>
    
    <!-- 联系对话框 -->
    <el-dialog
      title="产品咨询"
      :visible.sync="contactDialogVisible"
      width="400px"
      center>
      <div class="contact-dialog-header" v-if="infoData.length">
        <div class="contact-product-info">
          <img :src="infoData[0].ProductImg" :alt="infoData[0].ProductName">
          <div>
            <h4>{{infoData[0].ProductName}}</h4>
            <p>请填写您的联系方式，我们将尽快与您联系</p>
          </div>
        </div>
      </div>
      
      <el-form :model="contactForm" :rules="contactRules" ref="contactForm" label-position="top">
        <el-form-item label="您的姓名" prop="name">
          <el-input v-model="contactForm.name" placeholder="请输入您的姓名" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="contactForm.phone" placeholder="请输入联系电话" prefix-icon="el-icon-phone"></el-input>
        </el-form-item>
        <el-form-item label="咨询内容" prop="message">
          <el-input type="textarea" v-model="contactForm.message" rows="4" placeholder="请输入您想咨询的内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contactDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitContactForm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "proDetails",
  data(){
    return{
      infoData:[],
      recommendList: [],
      contactDialogVisible: false,
      showLightbox: false,
      contactForm: {
        name: '',
        phone: '',
        message: ''
      },
      contactRules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        message: [{ required: true, message: '请输入咨询内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  methods:{
    //获取产品详情
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntProductIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        // 获取到产品详情后，将分类ID传入获取推荐列表方法
        if(this.infoData.length > 0) {
          this.getRecommendList(this.infoData[0].ProductCate);
        }
      })
    },
    // 获取推荐产品列表
    getRecommendList(cateId){
      let data = {params:{ProductCate: cateId}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntProductSelect', data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        // 过滤掉当前产品，只显示其他同类产品
        const filteredProducts = res.data.filter(item => item.Id !== Number(this.$route.query.Id));
        this.recommendList = filteredProducts.slice(0, 3); // 只取3个推荐产品
      })
    },
    // 点击推荐产品
    handleRecommendClick(id){
      this.getInfo(id);
      this.$router.push({
        path: '/proDetails',
        query: { Id: id }
      });
    },
    // 显示联系对话框
    showContactDialog() {
      this.contactDialogVisible = true;
    },
    // 提交联系表单
    submitContactForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          // 这里可以添加提交表单的逻辑
          this.$message({
            message: '您的咨询已提交，我们会尽快联系您',
            type: 'success',
            duration: 3000
          });
          this.contactDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 格式化规格参数
    formatSpecs(specsString) {
      if (!specsString) return [];
      try {
        // 假设规格参数是以逗号分隔的键值对，如"尺寸:10cm,重量:5kg"
        return specsString.split(',').map(item => {
          const [name, value] = item.split(':');
          return { name, value };
        });
      } catch (e) {
        console.error('规格参数格式化错误:', e);
        return [];
      }
    }
  }
}
</script>

<style scoped>
.proDetails {
  background-color: #f8f9fa;
  padding-bottom: 60px;
}

/* 面包屑导航 */
.breadcrumb-wrapper {
  background-color: #fff;
  padding: 15px 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

/* 容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 产品容器 */
.product-container {
  animation: fadeIn 0.5s ease;
}

/* 产品概览区域 */
.product-overview {
  display: flex;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
  overflow: hidden;
}

/* 产品图片区域 */
.product-gallery {
  width: 45%;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
}

.main-image {
  position: relative;
  width: 100%;
  text-align: center;
}

.main-image img {
  max-width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.image-actions {
  position: absolute;
  bottom: 15px;
  right: 15px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.main-image:hover .image-actions {
  opacity: 1;
}

.zoom-btn {
  display: flex;
  align-items: center;
  background: rgba(255,255,255,0.9);
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

.zoom-btn i {
  margin-right: 5px;
  color: #1890ff;
}

.zoom-btn:hover {
  background: #1890ff;
  color: white;
}

.zoom-btn:hover i {
  color: white;
}

/* 产品信息区域 */
.product-info {
  flex: 1;
  padding: 30px;
}

.product-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.product-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}

.product-brief {
  color: #666;
  line-height: 1.6;
  margin-bottom: 25px;
  font-size: 15px;
  border-left: 3px solid #1890ff;
  padding-left: 15px;
  background: #f8f9fa;
  padding: 15px;
  border-radius: 0 4px 4px 0;
}

.product-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

/* 产品内容区域 */
.product-content {
  display: flex;
  gap: 30px;
}

.content-main {
  flex: 3;
  min-width: 0;
}

.content-sidebar {
  flex: 1;
  min-width: 250px;
}

/* 详情选项卡 */
.detail-tabs {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  overflow: hidden;
}

.detail-section {
  padding: 20px;
}

.section-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.detail-content {
  color: #333;
  line-height: 1.8;
  font-size: 14px;
}

.specs-table {
  margin-top: 20px;
}

/* 侧边栏样式 */
.sidebar-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  padding: 20px;
  margin-bottom: 20px;
}

.sidebar-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* 产品特点列表 */
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  color: #666;
}

.feature-list li i {
  color: #52c41a;
  margin-right: 10px;
  margin-top: 3px;
}

/* 推荐产品列表 */
.recommend-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.recommend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.recommend-item:hover {
  background: #f0f2f5;
}

.recommend-image {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.recommend-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.recommend-info {
  flex: 1;
  min-width: 0;
}

.recommend-info h4 {
  font-size: 14px;
  color: #333;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
}

.recommend-item:hover .recommend-info h4 {
  color: #1890ff;
}

/* 联系我们区域 */
.contact-section {
  text-align: center;
}

.contact-section p {
  margin-bottom: 15px;
  color: #666;
}

/* 图片灯箱 */
.lightbox-dialog :deep(.el-dialog__body) {
  padding: 0;
}

.lightbox-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.9);
  min-height: 500px;
  cursor: zoom-out;
}

.lightbox-content img {
  max-width: 90%;
  max-height: 80vh;
  object-fit: contain;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lightbox-close i {
  color: white;
  font-size: 20px;
}

.lightbox-close:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: rotate(90deg);
}

/* 联系对话框 */
.contact-dialog-header {
  margin-bottom: 20px;
}

.contact-product-info {
  display: flex;
  align-items: center;
  gap: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.contact-product-info img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
}

.contact-product-info h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.contact-product-info p {
  font-size: 13px;
  color: #666;
  margin: 0;
}

/* 加载状态 */
.loading-container {
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .product-overview {
    flex-direction: column;
  }
  
  .product-gallery {
    width: 100%;
    padding: 20px;
  }
  
  .product-content {
    flex-direction: column;
  }
  
  .content-sidebar {
    order: -1;
  }
}

@media (max-width: 768px) {
  .product-title {
    font-size: 20px;
  }
  
  .product-actions {
    flex-direction: column;
  }
  
  .product-actions .el-button {
    width: 100%;
  }
}
</style>